<template>
  <div>
    <v-tabs
      v-model="tab"
      background-color="cyan lighten-1"
      dark
      centered
      icons-and-text
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1">
        회원 정보
        <v-icon>mdi-account-box</v-icon>
      </v-tab>

      <v-tab href="#tab-2">
        결제 내역
        <v-icon>mdi-credit-card-settings-outline</v-icon>
      </v-tab>

      <v-tab href="#tab-3">
        리치고 구독 연동
        <v-icon color="white">mdi-account-multiple-outline</v-icon>
      </v-tab>

      <v-tab href="#tab-4">
        쿠폰 등록
        <v-icon color="white">mdi-card-bulleted</v-icon>
      </v-tab>

    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-1">
        <profile-component></profile-component>
      </v-tab-item>

      <v-tab-item value="tab-2">
        <payment-history></payment-history>
      </v-tab-item>

      <v-tab-item value="tab-3">
        <richgo-user-link/>
      </v-tab-item>

      <v-tab-item value="tab-4">
        <use-coupon/>
      </v-tab-item>

    </v-tabs-items>

  </div>
</template>

<script>
import ProfileComponent from '../components/ProfileComponent'
import PaymentHistory from '../components/PaymentHistory'
import UseCoupon from '../components/coupons/UseCoupon'
import RichgoUserLink from '../components/richgoUsers/RichgoUserLink.vue'


export default {
  components: {
    UseCoupon,
    RichgoUserLink,
    ProfileComponent,
    PaymentHistory
  },
  data() {
    return {
      tab: null
    }
  }
}
</script>
